import React, { useEffect, useState } from 'react'
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Home from './pages/Home'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import Team from './pages/Team'
import IntakeForm from './pages/IntakeForm'
import Features from './pages/Features'
import HowItWorks from './pages/HowItWorks'
import Pricing from './pages/Pricing'
import FAQ from './pages/Faq'
import Pipeline from './pages/Pipeline'
import { api } from './api'

function ProtectedRoute({ isReady, isAuthed, children }) {
  if (!isReady) return null
  return isAuthed ? children : <Navigate to="/login" />
}

export default function App() {
  const [isReady, setIsReady] = useState(false)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    ;(async () => {
      try {
        await api('/api/auth/me')
        setIsAuthenticated(true)
      } catch (e) {
        setIsAuthenticated(false)
      } finally {
        setIsReady(true)
      }
    })()
  }, [])

  return (
    <Router>
      <Routes>
        {/* Public marketing pages */}
        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/faq" element={<FAQ />} />

        {/* Auth */}
        <Route
          path="/login"
          element={<Login onLogin={() => setIsAuthenticated(true)} />}
        />
        <Route
          path="/register"
          element={<Register onLogin={() => setIsAuthenticated(true)} />}
        />

        {/* Protected app routes */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute isReady={isReady} isAuthed={isAuthenticated}>
              <Dashboard onLogout={() => setIsAuthenticated(false)} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/team"
          element={
            <ProtectedRoute isReady={isReady} isAuthed={isAuthenticated}>
              <Team />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pipeline"
          element={
            <ProtectedRoute isReady={isReady} isAuthed={isAuthenticated}>
              <Pipeline />
            </ProtectedRoute>
          }
        />

        {/* Public route — no auth required, clients access via emailed link */}
        <Route path="/intake/:token" element={<IntakeForm />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  )
}